import { render, staticRenderFns } from "./app-business-comp.vue?vue&type=template&id=a7959cc6&scoped=true&"
import script from "./js/app-business-comp.js?vue&type=script&lang=js&"
export * from "./js/app-business-comp.js?vue&type=script&lang=js&"
import style0 from "./app-business-comp.vue?vue&type=style&index=0&id=a7959cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7959cc6",
  null
  
)

export default component.exports